import { roles } from "../constants/roles";
import { HSP, MDC, MSP, IDP, WMS, VMI, TVS } from "../constants/common";

import images from "../assets/img/images";

export const sideBarMenu = [
  {
    name: "trainmanifest",
    url: "/siteEntranceExit/trainInOut",
    active: true,
    icons: {
      black: images.trainSidebar,
      green: images.trainSidebar,
    },
    subMenu: false,
    enabled: roles.user,
    restrict: TVS,
    category: "trainAccess",
  },

  {
    name: "supplychain",
    url: "/wms/requests_orders/requests",
    active: false,
    icons: {
      black: images.supply_chain,
      green: images.supply_chain,
    },
    subMenu: true,
    subPages: [
      {
        name: "orders",
        url: "/wms/requests_orders/requests",
        enabled: roles.user,
        restrict: WMS,
      },
      {
        name: "vmi_config",
        url: "/vmi-selector",
        enabled: roles.customerAdmin,
        permission: "vmi.configuration",
        restrict: WMS,
      },
      {
        name: "lookup",
        url: "/wms/lookup",
        enabled: roles.user,
        restrict: WMS,
      },
      {
        name: "inventory",
        url: "/wms/inventory",
        enabled: roles.customerAdmin,
        restrict: WMS,
        permission: "vmi.configuration"
      },
      {
        name: "po_search",
        url: "/wms/po-search",
        enabled: roles.customerAdmin,
        restrict: WMS,
      },
    ],
    enabled: roles.user,
    restrict: WMS,
  },

  {
    name: "idp",
    url: "/idp",
    category: "idp",
    active: false,
    icons: {
      black: images.idpLogo,
      green: images.idpLogoHover,
    },
    subMenu: false,
    enabled: roles.user,
    restrict: IDP,
  },
  {
    name: "hsp",
    active: false,
    icons: {
      black: images.hspIconGrey,
      green: images.hspIconColored,
    },
    subMenu: true,
    subPages: [
      {
        name: "siteAndZones",
        url: "/siteEntranceExit/walkInOut",
        enabled: roles.other,
        restrict: HSP,
        category: "humanAccess",
        icons: {
          black: images.siteViewIconBlack,
          green: images.siteViewIconColored,
        },
      },
      {
        name: "walkInNew",
        url: "/hsp/new/walkIn",
        enabled: roles.other,
        restrict: HSP,
        category: "humanAccess",
        dialog: true,
        icons: {
          black: images.walkInIcon,
          green: images.walkInColored,
        },
      },
      {
        name: "walkOutNew",
        url: "/hsp/new/walkOut",
        enabled: roles.other,
        restrict: HSP,
        category: "humanAccess",
        dialog: true,
        icons: {
          black: images.walkOutIcon,
          green: images.walkOutColored,
        },
      },
      {
        name: "hspOriginalStatusDashboard",
        url: "/dashboards/hspOriginalStatus",
        enabled: roles.other,
        category: "dashboards",
        restrict: HSP,
      },
      {
        name: "hspCurrentStatusDashboard",
        url: "/dashboards/hspCurrentStatus",
        enabled: roles.other,
        category: "dashboards",
        restrict: HSP,
      },
    ],
    enabled: roles.other,
    restrict: HSP,
  },
  {
    name: "mdc",
    active: false,
    icons: {
      black: images.mdcIconGrey,
      green: images.mdcIconColored,
    },
    subMenu: true,
    subPages: [
      {
        name: "siteAndZones",
        url: "/siteEntranceExit/driveInOut",
        enabled: roles.customerAdmin,
        category: "vehicleAccess",
        restrict: MDC,
        icons: {
          black: images.siteViewIconBlack,
          green: images.siteViewIconColored,
        },
      },
      {
        name: "driveIn",
        url: "/mdc/new/driveIn",
        enabled: roles.customerAdmin,
        category: "vehicleAccess",
        restrict: MDC,
        dialog: true,
        icons: {
          black: images.driveInIcon,
          green: images.driveInIcon,
        },
      },
      {
        name: "driveOut",
        url: "/mdc/new/driveOut",
        enabled: roles.customerAdmin,
        category: "vehicleAccess",
        restrict: MDC,
        dialog: true,
        icons: {
          black: images.driveOutIcon,
          green: images.driveOutIcon,
        },
      },
      {
        name: "siteAndZones",
        url: "/siteEntranceExit/walkInOut",
        enabled: roles.other,
        category: "humanAccess",
        restrict: HSP,
        icons: {
          black: images.siteViewIconBlack,
          green: images.siteViewIconColored,
        },
      },
      {
        name: "walkInNew",
        url: "/hsp/new/walkIn",
        enabled: roles.other,
        category: "humanAccess",
        restrict: HSP,
        dialog: true,
        icons: {
          black: images.walkInIcon,
          green: images.walkInColored,
        },
      },
      {
        name: "walkOutNew",
        url: "/hsp/new/walkOut",
        enabled: roles.other,
        category: "humanAccess",
        restrict: HSP,
        dialog: true,
        icons: {
          black: images.walkOutIcon,
          green: images.walkOutColored,
        },
      },
      {
        name: "mdcDashboard2",
        url: "/dashboards/mdcDashboard2",
        enabled: roles.customerAdmin,
        restrict: MDC,
        category: "dashboards",
      },
      {
        name: "mdcDashboard1",
        url: "/dashboards/mdcDashboard1",
        enabled: roles.customerAdmin,
        restrict: MDC,
        category: "dashboards",
      },
    ],
    enabled: roles.customerAdmin,
    restrict: MDC,
  },
  {
    name: "scheduler",
    icons: {
      black: images.schedulerIcon,
      green: images.schedulerIconColored,
    },
    iconsArrow: {
      black: images.schedulerIconArrow,
      green: images.schedulerIconArrowColored,
    },
    subMenu: "dynamic",
    subPages: [
      {
        name: "hsp",
        url: "/scheduler/hsp",
        enabled: roles.user,
        restrict: HSP,
      },
      {
        name: "mdc",
        url: "/scheduler/mdc",
        enabled: roles.user,
        restrict: MDC,
      },
    ],
    enabled: roles.user,
    permission: "schedules.read",
  },
  {
    name: "dashboards",
    active: false,
    icons: {
      black: images.dashboardIconGrey,
      green: images.dashboardIconColored,
    },
    subMenu: true,
    subPages: [
      {
        name: "onsiteCounts",
        enabled: roles.other,
        category: "general",
      },
      {
        name: "companyCounts",
        enabled: roles.other,
        category: "general",
      },
      {
        name: "hspOriginalStatusDashboard",
        url: "/dashboards/hspOriginalStatus",
        enabled: roles.other,
        restrict: HSP,
        category: HSP,
      },
      {
        name: "hspCurrentStatusDashboard",
        url: "/dashboards/hspCurrentStatus",
        enabled: roles.other,
        restrict: HSP,
        category: HSP,
      },
      {
        name: "mdcDashboard2",
        enabled: roles.customerAdmin,
        restrict: MDC,
        category: MDC,
      },
      {
        name: "mdcDashboard1",
        enabled: roles.customerAdmin,
        restrict: MDC,
        category: MDC,
      },
      {
        name: "mspMonthlyTransactionalStats",
        enabled: roles.customerAdmin,
        category: MSP,
      },
      {
        name: "vmiConfigurationMetrics",
        enabled: roles.customerAdmin,
        category: VMI,
      },
    ],
    enabled: roles.jrvAdmin,
  },
  {
    name: "search",
    active: false,
    icons: {
      black: images.searchIconGrey,
      green: images.searchIconGreen,
    },
    subMenu: false,
    subPages: [],
    enabled: roles.jrvAdmin,
    dialog: true,
  },
  {
    name: "me",
    url: "/profiles/me",
    active: false,
    icons: {
      black: images.meGrey,
      green: images.meColored,
    },
    subMenu: false,
    subPages: [],
    enabled: roles.user,
    permission: "vmi.configuration"
  },
  {
    name: "admin",
    active: false,
    icons: { black: images.adminIconBlack, green: images.adminIconColored },
    subMenu: true,
    subPages: [
      {
        name: "profiles",
        url: "/profiles",
        enabled: roles.customerAdmin,
      },
      {
        name: "events",
        url: "/events",
        enabled: roles.customerAdmin,
      },
      {
        name: "companies",
        enabled: roles.customerAdmin,
      },
      {
        name: "users",
        enabled: roles.customerAdmin,
      },
    ],
    enabled: roles.customerAdmin,
  },
];

export const profileMobileMenu = [
  "details",
  //"photos",
  //"events",
  //"stats",
  //"historyLog",
  "verification",
  "notes",
];
